import { Injectable } from '@angular/core';
import { IacctRange } from '../../../shared/models/models';
import { IacctService } from '../iacct.service';
import { Resolve } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class IacctRangeResolver implements Resolve<IacctRange[]> {
    constructor(private readonly iacctService: IacctService) { }

    resolve() {        
        return this.iacctService.getIacctRanges();
    }
}